import React from 'react';
import './Fog.css';

const Fog = () => {
  return (
    <section className="Fog"/>
  )
};

export default Fog;